import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunctionContext,
  UseQueryOptions,
} from "@tanstack/react-query";
import httpClient from "helpers/hybridHttpClient";

import applyCaseMiddleware from "axios-case-converter";
import type { AxiosError } from "axios";
import type { Trinket } from "types/layout";

export const generateLayoutTrinketsKey = (courseSlug: string) =>
  ["layoutTrinkets", "list", { courseSlug }] as const;

type LayoutTrinketsQueryKey = ReturnType<typeof generateLayoutTrinketsKey>;

export const fetchLayoutTrinkets = async ({
  queryKey: [, , { courseSlug }],
  meta: { ssrContext } = {},
}: QueryFunctionContext<LayoutTrinketsQueryKey>) => {
  const client = applyCaseMiddleware(httpClient(ssrContext));
  const { data } = await client.get<Trinket[]>(
    `/api/layout-user/trinket/${courseSlug}/`,
  );

  return data;
};

export const useLayoutTrinkets = <TData = Trinket[]>({
  courseSlug,
  ...options
}: Omit<
  UseQueryOptions<Trinket[], AxiosError, TData, LayoutTrinketsQueryKey>,
  "queryKey" | "queryFn"
> & {
  courseSlug: string;
}) =>
  useQuery({
    ...options,
    queryKey: generateLayoutTrinketsKey(courseSlug),
    queryFn: fetchLayoutTrinkets,
  });
